export default __webpack_public_path__ + "static/media/MaskGroup-4.7515bff1.svg";